import {get, post, put} from "@/services/api"

function commitActivities(commit, items) {
    if (items.length === 1) {
        commit('setActivity', items[0])
    } else if (items.length > 1) {
        if (items[0].types.includes('TEST')) {
            commit('setActivity', items[0])
            commit('setSeparateActivity', items[1])
        } else {
            commit('setActivity', items[1])
            commit('setSeparateActivity', items[0])
        }
    }
}

const state = {
    activities: [],
    didLoadActivities: false,
    didLoadActivity: false,
    activity: { id: null, pin: '', types: [], lessonId: null, seminarName: '', testName: '', sessionCode: '', testImageUrl: '', totalNumberOfQuestions: 0, timeForTest: 0, questions: [] },
    separateActivity: {id: null, pin: '', types: [], lessonId: null},
    activityStatusInfo: [],
    separateActivityStatusInfo: [],
    activityTypes: [],
    // submissionGraceSeconds and joinWindowMinutes stay null unless the teacher overrides the server defaults
    testActivityForm: {separateTest: false, duration: '1', test: null, submissionGraceSeconds: null, joinWindowMinutes: null}
};

const getters = {
    getActivities: state => state.activities,
    getActivityById: state => id => state.activities.find(t => t.id === id),
    didLoadActivities: state => state.didLoadActivities,
    activity: state => state.activity,
    activityStatusInfo: state => state.activityStatusInfo,
    separateActivity: state => state.separateActivity,
    separateActivityStatusInfo: state => state.separateActivityStatusInfo,
    activityTypes: state => state.activityTypes,
    testActivityForm: state => state.testActivityForm
};

const actions = {
    async fetchAllActivities({commit}) {
        commit('startedDataDownload');
        const response = await get('gamification/activities/');
        commit('setActivities', response.data.items);
        commit('finishedDataDownload');
    },

    async updateActivity({commit}, {item}) {
        const response = await put(`gamification/activities/${item.id}`, item);
        commit('updateActivity', response.data.content);
    },

    // What regenerating the QR codes would archive or delete - shown before the teacher confirms
    async fetchRegenerationImpact(_, {lessonId}){
        try {
            const response = await get(`gamification/activity/lesson/${lessonId}/regeneration_impact`)
            return response.data.content
        } catch (e) {
            console.log('error regeneration impact', e)
            return null
        }
    },

    async createActivity({commit}, {activityRequest}){
        const response = await post('gamification/activity/',activityRequest)
        commit('setActivity', response.data.content)
        return response.data.content
    },

    async createActivityWithTest({commit}, {activityRequest}){
        const response = await post(`gamification/activity/with-test?separateTest=${activityRequest.separateTest}`, activityRequest)
        commitActivities(commit, response.data.items)
        return response.data.items
    },
    restoreActivities({commit}, {activities}){
        commitActivities(commit, activities)
    },
    setActivityStatusInfo({commit}){
        let info = []
        if(state.activity.types.includes('ATT')){
            info.push({activeColor: true, locKey: 'gamification.attendance_activated', key: 'ATT'})
        }
        if(state.activity.types.includes('EVAL')){
            info.push({activeColor: true, locKey: 'gamification.evaluation_activated', key: 'EVAL'})
        }
        if(state.activity.types.includes('TEST')){
            info.push({activeColor: true, locKey: 'gamification.test_activated', key: 'TEST'})
            info.push({activeColor: false, locKey: 'gamification.test_not_started', key: 'TEST-EXE'})
        }

        let separateInfo = []
        if(state.separateActivity.types.includes('ATT')){
            separateInfo.push({activeColor: true, locKey: 'gamification.attendance_activated', key: 'ATT'})
        }
        if(state.separateActivity.types.includes('EVAL')){
            separateInfo.push({activeColor: true, locKey: 'gamification.evaluation_activated', key: 'EVAL'})
        }

        commit('setActivityStatusInfo', info)
        commit('setSeparateActivityStatusInfo', separateInfo)
    },
    testExecuted({commit}){
        commit('testExecuted')
    },
    clear({commit}){
        commit('setActivity', { id: null, pin: '', types: [], lessonId: null, seminarName: '', testName: '', sessionCode: '', testImageUrl: '', totalNumberOfQuestions: 0, timeForTest: 0, questions: [] })
        commit('setActivityStatusInfo',[])
        commit('setSeparateActivity',{id: null, pin: '', types: [], lessonId: null})
        commit('setSeparateActivityStatusInfo',[])
    },
    clearTestActivityForm({commit}){
        commit('setTestFormField', {key: 'separateTest', value: false})
        commit('setTestFormField', {key: 'duration', value: '1'})
        commit('setTestFormField', {key: 'test', value: null})
        commit('setTestFormField', {key: 'submissionGraceSeconds', value: null})
        commit('setTestFormField', {key: 'joinWindowMinutes', value: null})
    }

};

const mutations = {
    startedDataDownload: state => state.didLoadActivities = false,
    finishedDataDownload: state => state.didLoadActivities = true,
    setDidLoadActivity: (state, value) => (state.didLoadActivity = value),
    setActivities: (state, activities) => (state.activities = activities), 
    updateActivity: (state, item) => {
        const existing = state.activities.findIndex(q => q.id === item.id);
        if (existing > -1) {
            state.activities.splice(existing, 1, item);
        } else {
            state.activities.push(item);
        }
    },
    setActivity: (state, activity) => state.activity = activity,
    setSeparateActivity: (state, separateActivity) => state.separateActivity = separateActivity,
    setActivityStatusInfo: (state, statusInfo) => state.activityStatusInfo = statusInfo,
    setSeparateActivityStatusInfo: (state, statusInfo) => state.separateActivityStatusInfo = statusInfo,
    testExecuted: (state) => {
        const testExeIndex = state.activityStatusInfo.findIndex(info => info.key === 'TEST-EXE')
        if(testExeIndex !== -1){
            Object.assign(state.activityStatusInfo[testExeIndex],
                {activeColor: true, locKey: 'gamification.test_started', key: 'TEST-EXE'}
            )
        }
    },
    setActivityTypes: (state, types) => state.activityTypes = types,
    setTestFormField: (state, { key, value }) => {
        state.testActivityForm[key] = value;
    },

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
